//==============================================
// Block: Fund Grid
//==============================================

(function ($) {

var initBlockFundGrid = function( $block ) {
    
    let blockIconCell = $block.find('.block-fund-grid__cell');
    let blockIconCTA = $block.find('.block-fund-grid__cta');
    let blockImageBar= $block.find('.block-image-bar--left');
    let blockImageBox= $block.find('.block-image-box');

    let blockIconColInit = gsap.timeline({
        scrollTrigger: {
            trigger: $block,
            start: 'top 80%'
            //markers: true
        }
    });

    blockIconColInit.from(blockImageBox, {
        duration: 1,
        ease: "power1.out",
        width: '0'
    })
    .from(blockIconCell, {
        duration: 1,
        ease: "power1.out",
        stagger: 0.2,
        y: '8rem',
        opacity: '0'
    })
    .from(blockIconCTA, {
        duration: 1,
        ease: "power1.out",
        opacity: '0'
    }).from(blockImageBar, {
        duration: 1,
        ease: "power1.out",
        width: '0'
    });
    

};


// Initialize each block on page load (front end).
$(function(){
    $('.block-fund-grid').each(function(){
        initBlockFundGrid( $(this) );
    });
});

/* if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=block-fund-grid', initBlockFundGrid );
} */

})(jQuery);